import { Component } from '@ecs/Component';

/** A newly built ship materialising in its berth. */
export class Assembling implements Component {
  readonly type = 'Assembling';
  public frame = 0;

  constructor(public duration: number = 70) {}
}
